import config from 'config';
import { BackofficePartnerOffersGroupedByRowDTO, PartnerOffersGroupedByRowDTO } from './types';
import useResource from 'util/resource/useResource';

const baseUrl = config.COMPANIES_API_URL + '/partner-offers';

export const partnerOffersApiUrls = {
  backoffice: {
    list: () => `${baseUrl}/backoffice`,
    get: (id: string) => `${baseUrl}/backoffice/${id}`,
    create: `${baseUrl}/backoffice`,
    update: (id: string) => `${baseUrl}/backoffice/${id}`,
    delete: (id: string) => `${baseUrl}/backoffice/${id}`,
    rows: {
      create: `${baseUrl}/backoffice/rows`,
      update: (id: number) => `${baseUrl}/backoffice/rows/${id}`,
      delete: (id: number) => `${baseUrl}/backoffice/rows/${id}`,
    },
  },
  list: () => `${baseUrl}`,
};

export function usePartnerOffers() {
  return useResource<PartnerOffersGroupedByRowDTO[]>(partnerOffersApiUrls.list());
}

export function useBackofficePartnerOffers() {
  return useResource<BackofficePartnerOffersGroupedByRowDTO[]>(partnerOffersApiUrls.backoffice.list());
}
